import moment from "moment";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { userService } from "../../services/user-service";
import { AdminHomeOrderDto } from "../../types/dto/admin-home-order-dto";
import { Body14Regular } from "../typography/Body14Regular";
import { H2 } from "../typography/H2";

export const AdminOrderStatusSimplePanel = () => {
  const [orderStatus, setOrderStatus] = useState<AdminHomeOrderDto>({
    numQuotation: 0,
    numInvoiceReceived: 0,
    numInvoiceConfirmed: 0,
    numInvoiceShipmentStarted: 0,
    numInvoiceShipmentCompleted: 0,
    numInvoiceCanceled: 0,
    numInvoicePaymentPending: 0,
    numInvoiceTaxProcessed: 0,
  });

  const getData = async () => {
    const today = moment();
    const the30DaysAgo = today.clone().subtract(30, "days");
    const response = await userService.getAdminHomeOrder(
      the30DaysAgo.toISOString(),
      today.toISOString(),
    );
    if (response.ok) {
      setOrderStatus(response.data);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const data = [
    {
      id: uuidv4(),
      number: orderStatus.numQuotation,
      title: "견적서 발행",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceReceived,
      title: "발주 접수",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceConfirmed,
      title: "발주 확인",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceShipmentStarted,
      title: "배송 시작",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceShipmentCompleted,
      title: "배송 완료",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceTaxProcessed,
      title: "발주 완료",
      color: "orange",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceCanceled,
      title: "반품/취소",
      color: "red",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoicePaymentPending,
      title: "결제 대기",
      color: "red",
    },
    {
      id: uuidv4(),
      number: orderStatus.numInvoiceTaxProcessed,
      title: "세금계산서 발행",
      color: "red",
    },
  ];

  return (
    <div className="flex rounded-[4px] border-[1px] border-semantic-divider bg-primary-white">
      {data.map((item) => {
        return (
          <div className="flex flex-col w-[205px] h-[100px] items-center justify-center gap-[4px]">
            <H2 className={"text-secondary-2-" + item.color}>{item.number}</H2>
            <Body14Regular className="text-semantic-text-secondary hover:underline">
              {item.title}
            </Body14Regular>
          </div>
        );
      })}
    </div>
  );
};
